import React from 'react'
import {connect} from 'react-redux'




/**
 * HOC to incapsulate authorization 
 */
const AuthComponent = (Secured, NonSecured ) => {


    const mapStateToProps = (state) => {
        const { auth } = state
        return auth;
    }
    
    const mapDispatchToProps = (dispatch) => {
        return {        
            // onClose: () => dispatch({ type: A.HIDE_CONTACT }),
            // sent : () => dispatch({type: A.SEND_CONTACT} ), 
            // error : message => dispatch({type: A.SHOW_MESSAGE, payload:{message, type: "error"}}), 
            // resetMessage: () => dispatch( {type: A.RESET_CONTACT} )
        };
    };

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        class extends React.Component{        
            render(){ 
                const {user = {}, securedAppProps ={}, nonSecuredAppProps = {} } = this.props
                console.debug("user in auth:", user);
                console.debug("AuthWrap produced component props", this.props)
                return user ? <Secured {...{...securedAppProps, user} }/> : <NonSecured {...nonSecuredAppProps} /> 
            }
        }
    )
}




export default AuthComponent

